import React, { FC } from 'react';
import {
  PlateStyleProps,
  RegNumberPlate,
  VinPlate,
} from './LicensePlate.styled';

interface LicensePlateProps extends PlateStyleProps {
  regNumber?: string;
  vin?: string;
}

export const LicensePlate: FC<LicensePlateProps> = ({
  regNumber,
  vin,
  zoom,
  size,
}) => {
  if (!regNumber && vin) return <VinPlate zoom={zoom}>{vin}</VinPlate>;

  return (
    <RegNumberPlate zoom={zoom} size={size}>
      {regNumber || 'NO REG'}
    </RegNumberPlate>
  );
};
